<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('assitive_device_management.bill_generate') }} {{ $t('globalTrans.search')}}</h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group
                class="row"
                label-cols-sm="4"
                :label="$t('globalTrans.fiscal_year')"
                label-for="fiscal_year_id"
            >
              <b-form-select
                  plain
                  v-model="search.fiscal_year_id"
                  :options="fiscalYearList"
                  id="fiscal_year_id"
              >
                <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="supplier_info_id"
            >
              <template v-slot:label>
                <span>{{$t('assitive_device_management.supplier_name')}} </span> <span class="text-danger">*</span>
              </template>
              <b-form-select
                  plain
                  v-model="search.supplier_info_id"
                  :options="supplierInfoList"
                  id="supplier_info_id"
              >
                <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="p_o_no"
            >
              <template v-slot:label>
                <span>{{$t('assitive_device_management.p_o_no')}} </span> <span class="text-danger">*</span>
              </template>
              <b-form-select
                  plain
                  v-model="search.p_o_no"
                  :options="purchaseList"
                  id="p_o_no"
              >
                <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" sm="12" md="2" lg="2" xl="2">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">{{ $t('assitive_device_management.bill_generates') }}</h4>
            </template>
            <template v-slot:headerAction>
              <!-- <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
                {{  $t('globalTrans.add_new') }}
              </b-button> -->
              <router-link to="bill-generate-form" :class="'btn btn-success text-light'">{{  $t('assitive_device_management.new_bill') }}</router-link>
            </template>
            <template v-slot:body>
              <b-overlay :show="loadingState">
                <b-row>
                  <b-col md="12" class="table-responsive">
                    <b-table bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                      <template v-slot:cell(index)="data">
                        {{ $n(data.index + pagination.slOffset) }}
                      </template>
                      <template v-slot:cell(p_o_no)="data">
                        {{ $n(data.item.p_o_no, { useGrouping: false }) }}
                      </template>
                      <template v-slot:cell(supplier_info_id)="data">
                        {{ $n(data.item.supplier_info_id, { useGrouping: false }) }}
                      </template>
                      <template v-slot:cell(bill_process_date)="data">
                        {{ data.item.bill_process_date | dateFormat }}
                      </template>
                      <template v-slot:cell(action)="data">
                        <router-link title="View Details" :to="{ name: 'awareness_event_service.assistive_device_management.bill_generate_details', params: { id: data.item.id, item: data.item } }" class="btn btn-sm btn-info ml-2"><i class="ri-eye-line m-0 "></i></router-link>
                      </template>
                    </b-table>
                    <b-pagination
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total-rows="pagination.totalRows"
                      @input="searchData"
                      />
                  </b-col>
                </b-row>
              </b-overlay>
            </template>
          </iq-card>
      </b-col>
    </b-row>

  </b-container>
</template>
<script>
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import {
  BillGenerateList,
  purchaseMemoList
} from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import { helpers } from '@/mixins/helper-functions'

export default {
    mixins: [ModalBaseMasterList],
    components: {
    },
    data () {
        return {
          search: {
              fiscal_year_id: 0,
              supplier_info_id: 0,
              p_o_no: 0
          },
          purchaseList: [],
          purchaseMemoListAll: [],
          challanNoListAll: [],
          challanNoList: [],
          supplierInfoList: [],
          isLoading: false
        }
    },
    computed: {
      fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      },
      currentLocale () {
        return this.$i18n.locale
      },
      assistiveDeviceList: function () {
        return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.filter(item => item.status === 1)
      },
      idscCenterList: function () {
        return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1)
      },
      detailTitle () {
        return this.$t('assitive_device_management.budget_prepare') + ' ' + this.$t('globalTrans.details')
      },
      formTitle () {
            return (this.editItemId === 0) ? this.$t('assitive_device_management.bill_generate') + ' ' + this.$t('globalTrans.entry') : this.$t('assitive_device_management.bill_generate') + ' ' + this.$t('globalTrans.modify')
        },
      columns () {
          const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('globalTrans.fiscal_year'), class: 'text-left' },
                { label: this.$t('assitive_device_management.supplier_name'), class: 'text-left' },
                { label: this.$t('assitive_device_management.p_o_no'), class: 'text-left' },
                { label: this.$t('assitive_device_management.bill_process_date'), class: 'text-left' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
          ]

          let keys = []

          if (this.$i18n.locale === 'bn') {
              keys = [
                { key: 'index' },
                { key: 'fiscal_year_bn' },
                { key: 'supplier_name_bn' },
                { key: 'p_o_no' },
                { key: 'bill_process_date' },
                { key: 'action' }
              ]
          } else {
              keys = [
                { key: 'index' },
                { key: 'fiscal_year_en' },
                { key: 'supplier_name_en' },
                { key: 'p_o_no' },
                { key: 'bill_process_date' },
                { key: 'action' }
              ]
          }

          return labels.map((item, index) => {
              return Object.assign(item, keys[index])
          })
      }
    },
    watch: {
        // loadingState: function (newVal, oldVal) {
        //     if (newVal) {
        //         this.loadData()
        //     }
        // }
      'search.fiscal_year_id': function (newVal) {
        if (newVal) {
          this.supplierInfoList = this.getSupplierInfoList(newVal)
        } else {
          this.supplierInfoList = []
        }
      },
      'search.supplier_info_id': function (newVal) {
        if (newVal) {
          this.purchaseList = this.getMemoList(newVal)
        } else {
          this.purchaseList = []
        }
      }
    },
    created () {
      this.getPurchaseMemoList()
      this.loadData()
    },
    mounted () {
    },
    methods: {
      searchData () {
          this.loadData()
      },
      loadData () {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
          RestApi.getData(awarenessEventServiceBaseUrl, BillGenerateList, params).then(response => {
              if (response.success) {
                  this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                  this.paginationData(response.data)
              }
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
          })
      },
      getRelationalData (data) {
          const listData = data.map(item => {
              const fiscalYear = this.fiscalYearList.find(obj => obj.value === item.fiscal_year_id)
              const supplier = this.$store.state.AwarenessEventService.commonObj.supplierInfoList.find(obj => obj.value === item.supplier_info_id)
              const customItem = {
                  fiscal_year_en: fiscalYear?.text_en,
                  fiscal_year_bn: fiscalYear?.text_bn,
                  supplier_name_en: supplier?.text_en,
                  supplier_name_bn: supplier?.text_bn
              }
              item.details = item.details.map(detailItem => {
                const assistiveDevice = this.assistiveDeviceList.find(obj => obj.value === detailItem.assistive_device_id)
                const detailItemCustom = {
                  device_name_en: assistiveDevice?.text_en,
                  device_name_bn: assistiveDevice?.text_bn
                }
                return Object.assign({}, detailItem, detailItemCustom)
              })
              return Object.assign({}, item, customItem)
          })
          return listData
      },
      async getPurchaseMemoList () {
        this.isLoading = true
        const response = await RestApi.getData(awarenessEventServiceBaseUrl, purchaseMemoList)
        if (response.success) {
          this.purchaseMemoListAll = response.data.map(item => {
            const customItem = {
              value: item.value, text: this.$i18n.locale === 'bn' ? helpers.convertEnglishToBanglaNumber(item.text_bn) : item.text_en
            }
            return Object.assign({}, item, customItem)
          })
          this.search = Object.assign({}, this.search, { fiscal_year_id: this.$store.state.currentFiscalYearId })
        } else {
          this.purchaseMemoListAll = []
          this.search = Object.assign({}, this.search, { fiscal_year_id: this.$store.state.currentFiscalYearId })
        }
        this.isLoading = false
      },
      getMemoList (supplierInfoId) {
        let purchaseMemoList = this.purchaseMemoListAll
        if (supplierInfoId) {
          purchaseMemoList = purchaseMemoList.filter(item => item.fiscal_year_id === parseInt(this.search.fiscal_year_id) && item.supplier_info_id === parseInt(supplierInfoId))
        }
        return purchaseMemoList
      },
      getSupplierInfoList (fiscalYearId = null) {
        let supplierInfoList = this.$store.state.AwarenessEventService.commonObj.supplierInfoList.filter(item => item.status === 1)
        supplierInfoList = supplierInfoList.filter(item => {
          const purchaseMemoListItem = this.purchaseMemoListAll.find(obj => obj.supplier_info_id === item.value)
          if (purchaseMemoListItem !== undefined) {
            return item
          }
        })
        return supplierInfoList
      }
    }
}
</script>
